var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"east-operate"},[_c('div',{staticClass:"left"},[_vm._t("left")],2),_c('div',{staticClass:"right"},[_vm._t("right")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }